module.exports = __webpack_public_path__ + "static/media/stylus.40a2cf6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/stylus.png
// module id = 197
// module chunks = 0